// extracted by mini-css-extract-plugin
export default {"scoreDisplay":"xz5x9D1h","mobile":"mobile","scoreValue":"sXvPkgxL","starWrapper":"tltVCmKt","stars":"R8bp5xNB","starHalf":"uUYOGfT8","star":"_kZ2qBwa"};